import { render, staticRenderFns } from "./AddApolicestatuPage.vue?vue&type=template&id=2cead6aa"
import script from "./AddApolicestatuPage.vue?vue&type=script&lang=js"
export * from "./AddApolicestatuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports